import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {GeneralHttpHelperService} from "../../helpers/general-http-helper.service";

const NOTIFICATIONS_API_ROUTES = {
  GET_NOTIFICATIONS: 'user/notifications/bell',
  MARK_ALL_NOTIFICATIONS_AS_READ: 'user/notifications/mark_all_as_read'

}
@Injectable({
  providedIn: 'root'
})
export class NotificationsHttpService {

  constructor(private httpClient: HttpClient,
              private generalHttpHelperService: GeneralHttpHelperService) {
  }

  private getNotificationsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(NOTIFICATIONS_API_ROUTES.GET_NOTIFICATIONS, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getNotifications(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getNotificationsReq(urlParams).subscribe((res: any) => {
        resolve({
          hasUnreadNotifications: res.data.$unReadNotificationsExist,
          data: res.data.notifications.data,
          pagination: this.generalHttpHelperService.returnPagination(res.data.notifications)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private postMarkAllNotificationsAsReadReq(): Observable<any> {
    return this.httpClient.post(NOTIFICATIONS_API_ROUTES.MARK_ALL_NOTIFICATIONS_AS_READ, {}) as any;
  }

  postMarkAllNotificationsAsRead(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postMarkAllNotificationsAsReadReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
